import { Icon } from "../Icon";
import DragIndicator from "@servicetitan/hammer-icon/mdi/round/drag_indicator.svg";
import styles from "./DndHandle.module.scss";
import cx from "classnames";

/**
 * Props for the DndHandle component
 */
export type DndHandleProps = {
  /**
   * Additional CSS class names to apply to the drag handle.
   */
  className?: string;
};

/**
 * A reusable drag handle icon component for drag and drop interactions.
 *
 * Features:
 * - Standardized drag indicator icon
 * - Accessible with proper ARIA attributes
 * - Customizable styling through className prop
 * - Consistent visual appearance across applications
 * - Lightweight and performant
 * - Supports all standard HTML element props
 *
 * @example
 * <DndHandle className="custom-drag-handle" />
 */
export function DndHandle({ className }: { className?: string }) {
  const handleClasses = cx(styles.handle, className);
  return (
    <Icon svg={DragIndicator} className={handleClasses} role="presentation" />
  );
}
